module.exports = __webpack_public_path__ + "img/logo_semFundo.2c84cd57.svg";